var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CustomElement from '@byted/light-render/lib/shapes/CustomElement';
import { Group, Text } from '../element';
var BreadCrumb = /** @class */ (function (_super) {
    __extends(BreadCrumb, _super);
    function BreadCrumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreadCrumb.prototype.getObservedAttr = function () {
        return ['items'];
    };
    BreadCrumb.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { x: 0, y: 0, align: 'left', verticalAlign: 'top', items: [], activeColor: '#338AFF', textStyle: {
                fill: '#999999',
                fontSize: 12,
            }, onItemClick: function () { } });
    };
    BreadCrumb.prototype.render = function () {
        var _this = this;
        var _a = this.attr, x = _a.x, y = _a.y, activeColor = _a.activeColor, items = _a.items, textStyle = _a.textStyle, align = _a.align, verticalAlign = _a.verticalAlign;
        var group = new Group();
        var startX = 0;
        items.forEach(function (item, index) {
            var isLastPath = index === items.length - 1;
            var text = new Text(__assign(__assign({ x: startX, y: 0, text: item, textBaseline: 'top', textAlign: 'left' }, textStyle), { cursor: isLastPath ? 'default' : 'pointer', fill: isLastPath ? '#c1c1c1' : textStyle.fill, transitionProperty: 'none', onClick: function () { return !isLastPath && _this.attr.onItemClick(index); }, onMouseOver: function (event) {
                    if (isLastPath) {
                        return;
                    }
                    event.target.setAttr({
                        fill: activeColor,
                    });
                }, onMouseOut: function (event) {
                    if (isLastPath) {
                        return;
                    }
                    event.target.setAttr({
                        fill: textStyle.fill,
                    });
                } }));
            group.add(text);
            startX += text.getBBox().width;
            if (!isLastPath) {
                group.add(new Text(__assign({ x: startX + 22 / 2, text: '/', y: 0, textAlign: 'center', textBaseline: 'top', transitionProperty: 'none' }, _this.attr.textStyle)));
            }
            startX += 22;
        });
        var _b = group.getBBox(), width = _b.width, height = _b.height;
        var left = x;
        var top = y;
        if (align === 'left') {
            left = x;
        }
        else if (align === 'center') {
            left = x - width / 2;
        }
        else if (align === 'right') {
            left = x - width;
        }
        if (verticalAlign === 'top') {
            top = y;
        }
        else if (verticalAlign === 'middle') {
            top = y - height / 2;
        }
        else if (verticalAlign === 'bottom') {
            top = y - height;
        }
        group.setAttr({
            translateX: left,
            translateY: top,
            transitionProperty: 'none',
        });
        return group;
    };
    return BreadCrumb;
}(CustomElement));
export default BreadCrumb;
